import React from 'react';

interface ConsentAssignmentWrapperProps {
    taskIsDone: boolean;
    taskUrl: string;
}
const ConsentAssignmentWrapper: React.FC<React.PropsWithChildren<ConsentAssignmentWrapperProps>> = ({
    taskIsDone,
    taskUrl,
    children,
}) => {
    switch (taskIsDone) {
        case true:
            return <span className="consent-assignment-link consent-assignment-link--completed">{children}</span>;
        default:
            return (
                <a className="consent-assignment-link" href={taskUrl}>
                    {children}
                </a>
            );
    }
};

export default ConsentAssignmentWrapper;
